<template>
  <!-- 协会概况-->
  <div id="aa" class="Assocwindow">
    <!-- <Header></Header> -->
    <!-- <Navigate></Navigate> -->
    <div class="content">
      <div class="crumbs">
        <i class="iconfont icon-zhuye"></i>
        <span><router-link :to="{ name: 'home' }">首页</router-link></span>
        <i class="iconfont icon-youjiantou"></i>
          <span><a>协会概况</a></span>
      </div>
      <div class="content1">
          <div class="title">
            协会概况
          </div>
          <div  @mouseleave="mouseleave" class="navigation_content">
            
               
                <li><router-link :to="{name:'Assocpro'}">协会简介</router-link></li>
                <li><router-link :to="{name:'ContactInfo'}">协会领导</router-link></li>
                <li><router-link :to="{name:'Assocarticle'}">协会章程</router-link></li>
                <li><router-link :to="{name:'Instframe'}">组织机构</router-link></li>
                <li><router-link :to="{name:'Mandirect'}">常务理事</router-link></li>
                <li><router-link :to="{name:'Directunit'}">理事单位</router-link></li>
                <li><router-link :to="{name:'Admiscrit'}">规章制度</router-link></li>
                <li><router-link :to="{name:'Aplymember'}">申请入会</router-link></li>
            
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/public/heade/index";
import Navigate from "@/components/public/navigation/index";
import Foot from "@/components/public/foot/index";
import BannerLeft from "@/components/public/bannerLeft/index";
export default {
  name: "aa",
  data() {
    return {
      aa: [],
       DataDownloadList:[
        {
          name:'NonMember',
          title:'非会员'
        }
      ]
    //   contents:"",

    };
  },
  // methods: {
  //    GetHomePageBlockInfo1() {
  //     var that = this;
  //     that.$ajax
  //       .post('/SiteContentAPI/GetModel',{
  //         ContentID: "189385"
  //       })
  //       .then((res) => {
           
  //           this.aa = res.data;
        
  //       });
  //   },
  //  GetContentInfo(contentId,channelId) {
  //  console.log(contentId, "123456789");
  //     var that = this;
  //     that.$httphelper
  //       .GetContentInfo({
  //         journalId: 202007100001,
  //         pChannelId: 0,
  //         channelId: channelId,
  //         jChannelID: 0,
  //         dataSourceType: 1,
  //         dataShowType: 1,
  //         contentId:contentId
  //       })
  //       .then((res) => {
  //         if (res.code == 200) {
  //           console.log(res.data.siteContentInfoResult, "987654321");
  //          that.contents = res.data.siteContentInfoResult.content;
  //         }
  //       });
  //   }, 
  // },
  // created() {
  //   this.GetHomePageBlockInfo1(2828);
  // },
  components: {
    Header,
    Navigate,
    Foot,
    BannerLeft,
  },
};
</script>

<style lang="less" scoped>
#aa {
  width: 100%;
   height: 100%;
//   height: auto;
  .title {
  height: 60px;
  line-height: 60px;
  width: 100%;
  padding-left: 10px;
  font-size: 20px;
  font-weight: bold;
  color: #c01b22;
  border-bottom: 1px solid #e3e3e3;
}
.content1{
      background:#F8F8F8;
      padding-left: 35px;
      padding-right: 20px;
      padding-top: 5px;
      padding-bottom: 20px;
      li{
         .rig_bto_icon {
            width: 6px;
            height: 6px;
            background: #807e7e;
            position: absolute;
            border-radius: 50%;
            float: left;
            display: inherit;
            text-align: center;
            top: 23px;
            color: #fff;
            font-style: normal;
    }
      }
}
  li:hover{
    	a{
						color:#C01B22;
					}
  }
  li {
    list-style: none;
    width: 100%;
    height: 38px;
    font-size: 16px;
    color: #000000;
    // float: left;
    margin-right: 44px;
    cursor: pointer;
    padding: 15px 9px;
    background: #f8f8f8;
    
    .periodiCon_cluster_Cont_img {
      width: 175px;
      height: 120px;
      float: left;
      img {
        width: 100%;
        height: 100%;
      }
      
    }
    a {
          color: #333333;
          font-size: 16px;
        }
    .periodiCon_cluster_Cont_right {
      width: 678px;
      float: right;
      p:nth-child(1) {
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        line-clamp: 1;
        -webkit-box-orient: vertical;
        a {
          color: #333333;
          font-size: 18px;
        }
      }
      p:nth-child(2) {
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        line-clamp: 3;
        /*! autoprefixer: off */
        -webkit-box-orient: vertical;
        /* autoprefixer: on */
        color: #8b8b8b;
        font-size: 14px;
        margin-top: 7px;
        text-align: justify;
        text-indent: 2em;
      }
      p:nth-child(3) {
        width: 100%;
        height: 15px;
        margin-top: 9px;
        span:nth-child(1) {
          color: #909090;
          font-size: 14px;
          float: left;
        }
        span:nth-child(2) a {
          color: #909090;
          font-size: 16px;
          float: right;
        }
      }
    }
  }
  li:before{
        content: "";
        display: inline-block;
        width: 6px;
        height: 6px;
        background-color: #807e7e;
        /* border-radius:；圆角，使方形div变圆形 */
        border-radius: 50%;
        margin-right:25px;
            margin-bottom: 4px;
        vertical-align: middle;
    }
  .content {
    width: 1131px;
    height: 100%;
    margin: 0 auto;
    .crumbs {
      width: 1200px;
      height: 20px;
      position: relative;
      text-align: left;
      margin-top: 24px;
      margin-left: -1%;
      margin-bottom: 20px;
      line-height: 20px;
      span:nth-child(2) a {
        color: #000000;
        font-size: 16px;
        font-weight: bold;
        cursor: pointer;
      }
      i {
        color: #767c82;
        font-size: 18px;
        margin-left: 10px;
        font-weight: bold;
      }
      i:nth-child(1) {
        color: #000;
        margin-right: 5px;
      }
      span:nth-child(4) a {
        color: #c01b22;
        font-size: 16px;
        margin-left: 10px;
        font-weight: bold;
        cursor: pointer;
      }
    }
    .content_body{
        width: 1130px;
    height: 100%;
    margin-left: 3%;
    margin-top: 20px;
    // border: 1px solid #bbbbbb;
        .content_body_left{
          width:280px;
          height:100%;
          float:left;
        }
        .content_body_right{
        width: 1130px;
        height: auto;
        // margin-left: 3%;
          // float:right;
          // margin-left:15px;
        }
      }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/aa/index.vue